
export default function Footer() {
  return (
    <footer className="bg-[#0f1419] py-8">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-center justify-between text-sm text-gray-400">
          <p>© 2025 EL DORADO S.R.L. All rights reserved.</p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-white transition-colors cursor-pointer whitespace-nowrap"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
